import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subdealer, SubdealerCreate } from '../../../shared/interfaces/dealer.interfaces';
import { Observable } from 'rxjs';

const basePath = '/dealer/register';

@Injectable({
  providedIn: 'root'
})

export class DealerRegisterService {
  constructor(private http: HttpClient) { }

  // Creates a subdealer for the current dealer
  createDealer(payload: SubdealerCreate): Observable<Subdealer> {
    const body = payload;
    return this.http.post<Subdealer>(`${basePath}`, body);
  }

  // Resends the invitation email to a subdealer
  resendDealerInvitation(subdealerId: number) {
    const body = { 
      "id": subdealerId 
    };
    return this.http.put(`${basePath}`, body);
  }
}
